import { Dispatch } from 'redux';
import { useSelector, useDispatch } from "react-redux"
import { createCheckoutThunk } from '../thunks/checkout';
import NavBar from '../components/NavBar';
import TitleSection from '../components/TitleSection';
import CartList from '../components/CartList';
import Footer from '../components/Footer';
import UserCard from '../components/UserCard';
import HomeButton from '../components/HomeButton';
import ContentSection from '../components/ContentSection';
import DebugToolModalButton from '../components/debug/DebugToolModalButton';
import { DebugToolCartSnippet } from '../components/debug/DebugToolCartSnippet';
import { Accordion } from '../components/Accordion';
import { useState } from 'react';

function CartPage() {
  const cart: Cart = useSelector((state: AppState) => state.cart)
  const user: User = useSelector((state: AppState) => state.currentUser)
  const [isLoading,setIsLoading] = useState(false);

  const dispatch: Dispatch<any> = useDispatch()
  const onCheckout = () => {
    dispatch(createCheckoutThunk(cart, user))
    setIsLoading(true);
  }

  const isEmpty = (cart.items.length === 0)

  return (
    <div className='body'>
      <NavBar
        left={<HomeButton />}
        right={<UserCard />}
      />
      <TitleSection text='Your Cart'/>
      <ContentSection>
        <CartList />
        <div className='redirect-button'>
          <button className={`btn ${isEmpty ? 'gray' : 'green'} large`} onClick={() => onCheckout()} disabled={isEmpty}>
            { isLoading ? <div className='bar-loader'/> : 'Checkout' }
          </button>
        </div>
      </ContentSection>
      <Footer>
        <DebugToolModalButton header='Debug Tool'>
          <Accordion header='Checkout Payload' index='1' group='debug' defaultChecked={true}>
            <DebugToolCartSnippet/>
          </Accordion>
        </DebugToolModalButton>
      </Footer>
    </div>
  );
}

export default CartPage;
